import {
  registerDecorator,
  type ValidationOptions,
  type ValidationArguments,
} from 'class-validator';
import { validateEmbedCode } from '@builder4/shared/utils/videoHelpers';

/**
 * Validates that a value is either empty or a valid video embed code.
 * Uses validateEmbedCode from videoHelpers to validate iframe and allowed domains.
 */
export function IsVideoEmbedCode(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isVideoEmbedCode',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          if (typeof value !== 'string') {
            return false;
          }
          const result = validateEmbedCode(value);
          return result.isValid;
        },
        defaultMessage(args: ValidationArguments) {
          const value = args.value as string;
          if (typeof value === 'string' && value.trim()) {
            const result = validateEmbedCode(value);
            if (result.error) {
              return `${args.property}: ${result.error}`;
            }
          }
          return `${args.property} must be a valid iframe embed code from an allowed domain`;
        },
      },
    });
  };
}
